const domElements = {};
const API_STREETS_URL = '/schritt-1?type=157203835';

function initDomElements() {
  domElements.main = $('.order__step--1');
  if (domElements.main.length < 1) return false;
  domElements.streetInput = domElements.main.find('#streetCode');
  domElements.checkboxGroupTypes = domElements.main.find(
      '.form-field__checkbox-group--types');
  domElements.typeCheckboxes = domElements.checkboxGroupTypes.find(
      'input[type="checkbox"]');
  return true;
}

function step1() {
  if (!initDomElements()) {
    return false;
  }

  domElements.streetInput.select2({
    // language: {
    //   inputTooShort: function() {
    //     return 'Bitte geben sie mindestens drei Zeichen ein'
    //   }
    // },
    placeholder: 'Ihre Straße',
    minimumInputLength: 3,
    ajax: {
      url: API_STREETS_URL,
      delay: 100,
      data: function(params) {
        return {
          phrase: params.term
        };
      }
      // complete: function() {
      //     domElements.streetInput.append($("<option selected='selected'></option>").val(domElements.homeStreetInput.val()).text( domElements.homeStreetInput.val())).trigger('change');
      //}
    }
  });

  if (domElements.streetInput.data('street')) {
    domElements.streetInput.append($('<option selected=\'selected\'></option>').
        val(domElements.streetInput.data('streetcode')).
        text(domElements.streetInput.data('street'))).trigger('change');
  }

  domElements.typeCheckboxes.on('change', event => {
    toggleTypeRequirements();
  });

  toggleTypeRequirements();
}

function toggleTypeRequirements() {
  if (domElements.typeCheckboxes.eq(1).is(':checked')) {
    domElements.typeCheckboxes.eq(0).prop('required', false);
  } else {
    domElements.typeCheckboxes.eq(0).prop('required', true);
  }
}

export default step1;